import { Grid, Paper } from '@material-ui/core';
import _ from 'lodash';
import React from 'react';
import { DataApi } from '../../../providers/api-provider';
import ButtonWithStore from './ButtonWithStore';
import { handleInputState, showError, showSuccess } from './helpers';
import { LocalizationConfig } from '../../../config/app'

//Form That Handles State of its fields dynamicly and performs Add/Update Actions
class ApiForm extends React.Component {
    constructor(props) {
        super(props);
        this.handleInputState = this.handleInputState.bind(this);

    }
    static defaultProps = {
        redirect: '',
        actionMessage: 'Saved Successfully',
        actionType: 'update',
        onFormSaved: function (data) { },
        onFormFailed: function (res) { },
        onFormFetched: function (res) { },
        fetchWithLock: false,
    }
    state = {
        errors: {
            enabled: true,
        },
        form: {
        },
        loading: false
    }
    /*
    -----------------------------------------------------------------------
    API Functions
    -----------------------------------------------------------------------
    */
    /* API Call */
    performAction = async (store) => {
        if (this.checkErrors()) {
            this.setState({ loading: true });
            try {
                let res = await DataApi[this.props.actionType](this.props.actionUrl, this.state.form);
                //Show SnackBar
                const newState = {};
                if (this.props.actionMessage)
                    showSuccess(this.props.actionMessage);
                newState.loading = false;
                this.setState(newState);
                this.props.onFormSaved(res.data);
                if (this.props.redirect !== '')
                    this.props.history.push(this.props.redirect);
                return true;
            } catch (error) {
                this.props.onFormFailed(error);
                let newState = this.state;
                //Show SnackBar
                if (typeof (error.response) !== 'undefined') {
                    let data = error.response.data;
                    if (typeof (data) === 'string')
                        data = JSON.parse(data);
                    showError(data.message);
                    if (typeof (error.response.data.errors) !== 'undefined') {
                        for (let field in this.state.form) {
                            if (typeof (error.response.data.errors[field]) !== "undefined") {
                                newState.errors[field] = error.response.data.errors[field][0];
                            } else {
                                //Localized Fields
                                let hasError = false;
                                for (let localeKey in LocalizationConfig.locales) {
                                    const locale = LocalizationConfig.locales[localeKey];
                                    let fieldError = error.response.data.errors[field + '.' + locale.code];
                                    if (Array.isArray(fieldError)) {
                                        newState.errors[field] = fieldError[0] + ' (' + locale.name + ')'
                                        hasError = true;
                                        break;
                                    }
                                }
                                //Reset
                                if (!hasError && typeof (newState.errors[field]) !== "undefined")
                                    newState.errors[field] = false;
                            }
                        }

                        newState.errors.enabled = true;
                        //Scroll to element
                        var element = Object.keys(error.response.data.errors)[0].split('.')[0];
                        element = document.querySelector("[data-form-element=" + element + "]")
                        if (element)
                            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        //
                    }
                }
                newState.loading = false;
                this.setState(newState);
            }
        } else {
            showError('Checkout required fields please!');
            this.props.onFormFailed(this.state.errors, true);
        }
        return false;

    }
    /* Trigger Form Data loaded*/
    formDataDidFetch = (data) => { this.props.onFormFetched(data); }
    //Fetching Form Data
    fetchData = async () => {
        this.setState({ loading: true });
        const res = await DataApi.getOne(
            this.props.fetchUrl, this.props.fetchWithLock, false
        )
        await this.setState({
            form: { ...this.state.form, ..._.pick(res.data, _.keys(this.state.form)) },
            loading: false
        });
        this.formDataDidFetch(res.data);
    }
    //Fetching Refill Data
    triggerFetchRefillData = async (refillAction) => {
        this.setState({ loading: true });
        const res = await DataApi.getOne(refillAction)
        await this.setState({
            form: { ...this.state.form, ..._.pick(res.data, _.keys(this.state.form)) },
            loading: false
        });
        this.formDataDidFetch(res.data);
    }
    /*
    -----------------------------------------------------------------------
    RENDER Functions
    -----------------------------------------------------------------------
    */
    /* Validate Form */
    checkErrors = () => {
        let errors = { enabled: false };
        for (let field in this.state.errors) {
            if (field === 'enabled') continue;
            errors[field] = this.state.form[field] === '' || this.state.form[field] === null;
            if (errors[field])
                errors.enabled = true;
        }
        this.setState({
            errors: errors,
        });
        return !errors.enabled;
    }
    /* Hanle State Management of form */
    handleInputState = handleInputState;
    onChange = async (event) => {
        const { name, value, render } = await this.handleInputState(event);
        const refillAction = _.get(render, name + '.onChangeRefill');
        if (_.get(render, name + '.onChangeRefill'))
            this.triggerFetchRefillData(refillAction(value))
    }
    //Triggering Fetching Data
    triggerFetchData() {
        if (this.props.fetchUrl)
            this.fetchData();
    }
    render() {
        return (
            <Paper elevation={2} className="allpadding-lg">
                <form >
                    <Grid container spacing={2}>
                    </Grid>
                    <ButtonWithStore title="Action" disabled={this.state.loading} action={this.performAction} />
                </form>
            </Paper>
        )
    }
}


export default ApiForm;